import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { isNumber } from 'util';
import { padNumber, toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';


export abstract class NgbDateParserFormatter {
  abstract parse(value: string): NgbDate;
  abstract format(date: NgbDate): string;
}

export class NgbDateISOParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDate {
    if (!value) {
      return null;
    }

    const dateParts = value.trim().split('-');

    return this.getNgbDate(dateParts);
  }

  private getNgbDate(dateParts: string[]): NgbDate {

    if (dateParts.length === 1 && isNumber(dateParts[0])) {
      return new NgbDate(toInteger(dateParts[0]), null, null);
    } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
      return new NgbDate(toInteger(dateParts[0]), toInteger(dateParts[1]) - 1, null);
    } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
      return new NgbDate(toInteger(dateParts[0]), toInteger(dateParts[1]) - 1, toInteger(dateParts[2]));
    }

    return null;
  }

  format(date: NgbDate): string {
    return date ?
      `${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}` :
      '';
  }
  static validNgbDate(data: any): boolean {
  
    const strRegex = [
      '(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)',
      '[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2][0])([0-9]\\d$))',
      '|(^29[/]02[/](19|[2][0])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56)$)'
    ].join('');

    if (data === undefined || data === null) {
      return false;
    }
    try {
      const dataNgb = `${data.day.toString().padStart(2, '0')}/${data.month.toString().padStart(2, '0')}/${data.year}`;

      if (data.year === 2079) {
        if (data.month > 6) {
          return true;
        } else if (data.month === 6 && data.day > 6) {
          return true;
        }
      }
      const regex = new RegExp(strRegex);

      if (regex.test(dataNgb) && dataNgb !== '') {
        return true;
      }
      return false;
    } catch (ex) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ngb-date-parser-formatter.ts